import { HistoricoControleComissaoPedidoStyles } from './HistoricoControleComissaoPedido.styles'

export function historicoControleComissaoPedidoIO() {
  return {
    styles: HistoricoControleComissaoPedidoStyles
  }
}

export type HistoricoControleComissaoPedidoIO = ReturnType<typeof historicoControleComissaoPedidoIO>
